/**
 * The touch action buttons' words (ADR-061's amendment of 2026-10-31, decisions 7 and 12), every one a draft for the
 * author. None names a key: they are shown on a page with no keyboard. `interact` is the Interact button's label with
 * nothing in reach, `pickUp` its label beside a ground item, and a verb or a door reads as the world prompt does.
 */
export const TOUCH = {
  actions: "Actions",
  attack: "Attack",
  interact: "Use",
  pickUp: "Pick up",
  jump: "Jump",
  sprint: "Sprint",
  tool: "Tool",
  stance: {
    sheathe: "Sheathe weapon",
    draw: "Draw weapon",
  },
} as const;
